import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, Fragment as _Fragment, normalizeClass as _normalizeClass, renderList as _renderList, vModelSelect as _vModelSelect, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "wrap"
}
const _hoisted_2 = {
  key: 0,
  class: "dup-box"
}
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "field" }
const _hoisted_5 = { class: "phone-row" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 3,
  class: "open-leads"
}
const _hoisted_8 = { class: "field" }
const _hoisted_9 = { class: "field" }
const _hoisted_10 = { class: "field" }
const _hoisted_11 = { class: "field" }
const _hoisted_12 = { class: "field" }
const _hoisted_13 = { class: "field" }
const _hoisted_14 = ["value"]
const _hoisted_15 = {
  key: 1,
  class: "field"
}
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "card" }
const _hoisted_18 = { class: "field" }
const _hoisted_19 = { class: "field" }
const _hoisted_20 = { class: "field" }
const _hoisted_21 = { class: "field" }
const _hoisted_22 = { class: "card" }
const _hoisted_23 = { class: "field" }
const _hoisted_24 = { class: "field" }
const _hoisted_25 = { class: "field" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = {
  key: 1,
  class: "state"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_DealLines = _resolveComponent("DealLines")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, { class: "custom-toolbar" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    color: "light",
                    onClick: _ctx.goBack
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "icon-only",
                        icon: _ctx.arrowBackOutline
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, { class: "custom-title" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.leadId ? 'Edit Lead' : 'New Lead'), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        fullscreen: true,
        class: "page-bg"
      }, {
        default: _withCtx(() => [
          (_ctx.meta)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_ctx.duplicate)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _cache[21] || (_cache[21] = _createElementVNode("b", null, "Possible duplicate.", -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.duplicate), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("section", _hoisted_3, [
                  _cache[38] || (_cache[38] = _createElementVNode("h3", null, "Client", -1)),
                  _createElementVNode("div", _hoisted_4, [
                    _cache[22] || (_cache[22] = _createElementVNode("label", null, [
                      _createTextVNode("Phone "),
                      _createElementVNode("span", { class: "req" }, "*")
                    ], -1)),
                    _createElementVNode("div", _hoisted_5, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.contact_phone) = $event)),
                        type: "tel",
                        onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.lookup && _ctx.lookup(...args))),
                        onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.lookup && _ctx.lookup(...args)), ["enter"])),
                        maxlength: "30",
                        placeholder: "01XXXXXXXXX"
                      }, null, 544), [
                        [_vModelText, _ctx.form.contact_phone]
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "find",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.lookup && _ctx.lookup(...args)))
                      }, "Find")
                    ]),
                    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "hint" }, "Start with the phone: an existing client's details fill in automatically.", -1))
                  ]),
                  (_ctx.found)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["found", _ctx.found.type])
                      }, [
                        (_ctx.found.type === 'client')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _cache[24] || (_cache[24] = _createElementVNode("b", null, "Existing client:", -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.found.summary.name), 1),
                              (_ctx.found.summary.company)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_6, " · " + _toDisplayString(_ctx.found.summary.company), 1))
                                : _createCommentVNode("", true),
                              _createTextVNode(" · " + _toDisplayString(_ctx.found.summary.ships) + " ship(s) · " + _toDisplayString(_ctx.found.summary.leads) + " lead(s), " + _toDisplayString(_ctx.found.summary.won) + " won. ", 1)
                            ], 64))
                          : (_ctx.found.type === 'lead')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _cache[25] || (_cache[25] = _createElementVNode("b", null, "Known prospect:", -1)),
                                _createTextVNode(" details copied from lead " + _toDisplayString(_ctx.found.summary.from_lead) + " (" + _toDisplayString(_ctx.found.summary.status) + ").", 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _cache[26] || (_cache[26] = _createElementVNode("b", null, "New client:", -1)),
                                _cache[27] || (_cache[27] = _createTextVNode(" no client or earlier lead has this number.", -1))
                              ], 64)),
                        (_ctx.found.open_leads.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Open leads: " + _toDisplayString(_ctx.found.open_leads.map(l => l.lead_code + ' (' + l.product + ', ' + l.stage + ', ' + l.owner + ')').join('; ')), 1))
                          : _createCommentVNode("", true)
                      ], 2))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_8, [
                    _cache[28] || (_cache[28] = _createElementVNode("label", null, [
                      _createTextVNode("Company name "),
                      _createElementVNode("span", { class: "req" }, "*")
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.company_name) = $event)),
                      onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.checkDuplicate && _ctx.checkDuplicate(...args))),
                      maxlength: "255"
                    }, null, 544), [
                      [_vModelText, _ctx.form.company_name]
                    ]),
                    _cache[29] || (_cache[29] = _createElementVNode("div", { class: "hint" }, "If the company already uses Jahaji, type its exact name so the lead links to it.", -1))
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _cache[30] || (_cache[30] = _createElementVNode("label", null, [
                      _createTextVNode("Contact person "),
                      _createElementVNode("span", { class: "req" }, "*")
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.contact_name) = $event)),
                      maxlength: "255"
                    }, null, 512), [
                      [_vModelText, _ctx.form.contact_name]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _cache[31] || (_cache[31] = _createElementVNode("label", null, "Designation", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.contact_designation) = $event)),
                      maxlength: "255"
                    }, null, 512), [
                      [_vModelText, _ctx.form.contact_designation]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _cache[32] || (_cache[32] = _createElementVNode("label", null, "Email", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.contact_email) = $event)),
                      type: "email"
                    }, null, 512), [
                      [_vModelText, _ctx.form.contact_email]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _cache[33] || (_cache[33] = _createElementVNode("label", null, "Address", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.address) = $event)),
                      maxlength: "255"
                    }, null, 512), [
                      [_vModelText, _ctx.form.address]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _cache[35] || (_cache[35] = _createElementVNode("label", null, "Port", -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.port_id) = $event))
                    }, [
                      _cache[34] || (_cache[34] = _createElementVNode("option", { value: "" }, "—", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.meta.ports, (p) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: p.id,
                          value: p.id
                        }, _toDisplayString(p.port_name), 9, _hoisted_14))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.form.port_id]
                    ])
                  ]),
                  (!_ctx.leadId && _ctx.meta.user.full_access)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _cache[37] || (_cache[37] = _createElementVNode("label", null, "Owner", -1)),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.owner_id) = $event))
                        }, [
                          _cache[36] || (_cache[36] = _createElementVNode("option", { value: "" }, "Me", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.meta.users, (u) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: u.id,
                              value: u.id
                            }, _toDisplayString(u.name), 9, _hoisted_16))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.form.owner_id]
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("section", _hoisted_17, [
                  _cache[46] || (_cache[46] = _createElementVNode("h3", null, "Classification", -1)),
                  _createElementVNode("div", _hoisted_18, [
                    _cache[40] || (_cache[40] = _createElementVNode("label", null, [
                      _createTextVNode("Source of sale "),
                      _createElementVNode("span", { class: "req" }, "*")
                    ], -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.source) = $event))
                    }, [
                      _cache[39] || (_cache[39] = _createElementVNode("option", { value: "" }, "Select", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.meta.sources, (o) => {
                        return (_openBlock(), _createElementBlock("option", { key: o }, _toDisplayString(o), 1))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.form.source]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _cache[42] || (_cache[42] = _createElementVNode("label", null, "How we found them", -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.source_detail) = $event))
                    }, [
                      _cache[41] || (_cache[41] = _createElementVNode("option", { value: "" }, "—", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.meta.source_details, (o) => {
                        return (_openBlock(), _createElementBlock("option", { key: o }, _toDisplayString(o), 1))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.form.source_detail]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _cache[44] || (_cache[44] = _createElementVNode("label", null, "Segment", -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.segment) = $event))
                    }, [
                      _cache[43] || (_cache[43] = _createElementVNode("option", { value: "" }, "—", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.meta.segments, (o) => {
                        return (_openBlock(), _createElementBlock("option", { key: o }, _toDisplayString(o), 1))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.form.segment]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _cache[45] || (_cache[45] = _createElementVNode("label", null, "Priority", -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.priority) = $event))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.meta.priorities, (o) => {
                        return (_openBlock(), _createElementBlock("option", { key: o }, _toDisplayString(o), 1))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.form.priority]
                    ])
                  ])
                ]),
                _createElementVNode("section", _hoisted_22, [
                  _cache[50] || (_cache[50] = _createElementVNode("h3", null, [
                    _createTextVNode("Deal "),
                    _createElementVNode("small", null, "(copied into the Sale when you convert)")
                  ], -1)),
                  _createVNode(_component_DealLines, {
                    modelValue: _ctx.deal,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.deal) = $event)),
                    products: _ctx.products,
                    "month-options": _ctx.meta.contract_month_options || undefined,
                    hint: "A client can have one open lead per product.",
                    onProductChanged: _ctx.checkDuplicate
                  }, null, 8, ["modelValue", "products", "month-options", "onProductChanged"]),
                  _createElementVNode("div", _hoisted_23, [
                    _cache[47] || (_cache[47] = _createElementVNode("label", null, "Expected close", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.expected_close_date) = $event)),
                      type: "date"
                    }, null, 512), [
                      [_vModelText, _ctx.form.expected_close_date]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _cache[48] || (_cache[48] = _createElementVNode("label", null, "Next follow-up", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.next_follow_up_at) = $event)),
                      type: "datetime-local"
                    }, null, 512), [
                      [_vModelText, _ctx.form.next_follow_up_at]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _cache[49] || (_cache[49] = _createElementVNode("label", null, "Remarks", -1)),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.remarks) = $event)),
                      maxlength: "2000"
                    }, null, 512), [
                      [_vModelText, _ctx.form.remarks]
                    ])
                  ])
                ]),
                _createElementVNode("button", {
                  class: "btn-save",
                  disabled: _ctx.saving,
                  onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
                }, _toDisplayString(_ctx.saving ? 'Saving...' : (_ctx.leadId ? 'Save changes' : 'Create lead')), 9, _hoisted_26)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createVNode(_component_ion_spinner, { name: "crescent" })
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}